module.exports = __webpack_public_path__ + "static/media/luck_token.1ee10b7e.png";